import type { Observable } from 'rxjs';

export abstract class ChatsFactoryService<T> {
  abstract createChat(entityId: number, payload: T): Observable<number>;
}
